import React, { useState, useEffect, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import GatesForm from 'components/sales/formSection/gates/creategatesForm';
import GatesFormApt from 'components/sales/formSection/gates/creategatesFormApt';
import { Button } from 'react-bootstrap';
import localization from 'assets/localization/localization';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const AddGate = ({
  match,
  typeList,
  leadGates = null,
  gateTypeList,
  addCorporateGate,
  fetchLeadGate = null,
  addApartmentGate,
  
}) => {
  const [leadId, setleadId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isFiled, setIsFiled] = useState();
  const { baseUrl } = useContext(BaseUrl);
  
  const gateInputs = {
    gateDetails: null,
  };
  const [gateData, setGateData] = useState(gateInputs);
  const [isModal, setIsModal] = useState(false);
  

useEffect(() => {
    if (leadGates !== null)
      (async () => {
        setIsLoading(true);
        await fetchLeadGate(match.params.id);
        setIsLoading(false);
      })();
  }, []);
  // console.log(leadGates);

  useEffect(() => {
    setleadId(match.params.id);
  }, []);

  const teamName = JSON.parse(localStorage.getItem('profileDetails'))[0].team_id;
  const handleSubmit = () => {
    // console.log(gateData);
    if (teamName && teamName === 8) {
      // console.log(leadId);
      if (gateData.gateDetails.lead_id === undefined) {
        gateData.gateDetails.lead_id = leadId;
      }
      const { gateDetails } = gateData;
      setIsFiled(false);
      setIsModal(true);
      addApartmentGate(gateDetails);
    } else {
      const { gateDetails } = gateData;
      if (
        gateDetails === null ||
        gateDetails.gates?.length <= 0 ||
        gateDetails.gates[0].current_setup_id === ''
      ) {
        setIsFiled(true);
        setIsModal(false);
        return false;
      } else {
        setIsFiled(false);
        setIsModal(true);
        const data = gateDetails.gates.filter(
          (obj) => obj.current_setup_id !== ''
        );
        gateDetails.gates = data;
        addCorporateGate(gateDetails);
      }
    }
  };

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submitDtl}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  const handleModalHide = () => setIsModal(false);

  const handleGates = (val) => {
    setGateData({ ...gateData, gateDetails: val });
  };

  return (
    <Layout
      title={localization.gateHead}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
    >
      {teamName && teamName == 8 ? (
      <GatesFormApt
        typeList={typeList}
        leadGates={leadGates}
        gateTypeList={gateTypeList ? gateTypeList : null}
        handleValue={handleGates}
        leadId={leadId}
        noTag={true}
      />

      ) : 
      <GatesForm
        typeList={typeList}
        leadGates={leadGates}
        gateTypeList={gateTypeList ? gateTypeList : null}
        handleValue={handleGates}
        leadId={leadId}
        noTag={true}
      />}

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.preB2bSuccess}</h5>
          <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.viewSiteList} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default AddGate;
